module.exports = __webpack_public_path__ + "img/ez-theme-switcher-ic-register-bg.a4271207.a4271207.png";